var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1942 0 0 11.1942 0 25C0 38.8058 11.1942 50 25 50C38.8058 50 50 38.8058 50 25C50 11.1942 38.8058 0 25 0ZM26.7857 37.0536C26.7857 37.2991 26.5848 37.5 26.3393 37.5H23.6607C23.4152 37.5 23.2143 37.2991 23.2143 37.0536V21.875C23.2143 21.6295 23.4152 21.4286 23.6607 21.4286H26.3393C26.5848 21.4286 26.7857 21.6295 26.7857 21.875V37.0536ZM25 17.8571C24.2991 17.8428 23.6317 17.5543 23.141 17.0536C22.6504 16.5528 22.3755 15.8797 22.3755 15.1786C22.3755 14.4775 22.6504 13.8043 23.141 13.3036C23.6317 12.8028 24.2991 12.5143 25 12.5C25.7009 12.5143 26.3683 12.8028 26.859 13.3036C27.3496 13.8043 27.6245 14.4775 27.6245 15.1786C27.6245 15.8797 27.3496 16.5528 26.859 17.0536C26.3683 17.5543 25.7009 17.8428 25 17.8571Z",
    fill: "#00739E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationIcon);
export default __webpack_public_path__ + "static/media/informationIcon.54720bbace0b6e1cbd433b7f8d73242e.svg";
export { ForwardRef as ReactComponent };